import { Style } from '@components/style';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import DatePicker, { Day } from '@hassanmojab/react-modern-calendar-datepicker';
import moment from 'moment';
import twLocale from '@/ui/CustomizeDatePicker/twLocale';
import './CustomizeDatePicker.scss';

const { blackColor, gray3Color } = new Style().getUiConfig();

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

function CustomizeDatePicker({ value, onChange, maxDate, minDate }) {
  const [selectedDay, setSelectedDay] = useState<Day | null>();

  const getSelectedDayMoment = (day) => {
    if (!day) return null;

    return moment(`${day.year}-${day.month}-${day.day}`, DEFAULT_DATE_FORMAT);
  };

  const selectedDayString = useMemo(() => {
    return getSelectedDayMoment(selectedDay)?.format(DEFAULT_DATE_FORMAT) || '';
  }, [selectedDay]);

  const updateSelectedDay = (date) => {
    setSelectedDay(date);

    onChange(getSelectedDayMoment(date)?.toDate());
  };

  useEffect(() => {
    if (!value || !(value instanceof Date)) return;

    const day = {
      year: value.getFullYear(),
      month: value.getMonth() + 1,
      day: value.getDate(),
    };

    if (day !== selectedDay) {
      setSelectedDay(day);
    }
  }, [value]);

  // render regular HTML input element
  const renderCustomInput = ({ ref }) => (
    <input
      style={{
        padding: '10px',
        width: '100%',
        height: '42px',
        fontSize: '16px',
        borderRadius: '10px',
        border: `1px solid ${gray3Color}`,
        color: `${blackColor}`,
      }}
      value={selectedDayString}
      readOnly
      ref={ref} // necessary
      placeholder="YYYY-MM-DD"
    />
  );

  return (
    <div>
      <DatePicker
        value={selectedDay}
        onChange={updateSelectedDay}
        renderInput={renderCustomInput}
        shouldHighlightWeekends
        wrapperClassName="w-100"
        colorPrimary="#58b6a8"
        calendarClassName="responsive-calendar"
        locale={twLocale}
        minimumDate={minDate}
        maximumDate={maxDate}
      />
    </div>
  );
}

CustomizeDatePicker.defaultProps = {
  value: null,
  onChange: () => {},
  maxDate: null,
  minDate: null,
};

CustomizeDatePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  maxDate: PropTypes.any,
  minDate: PropTypes.any,
};

export default CustomizeDatePicker;
